import Navigation from "../Blocks/Navigation";
import {Hamburger} from "../Blocks/Hamburger";

export class Header {
  constructor() {
    this.lastKnownScrollY = 0;
    this.ticking = false;
    this.header = document.querySelector(".header");


    this.updateHeader = this.updateHeader.bind(this);
    this.watchForAddingScrollState();

    new Navigation(this.header.querySelector('.navigation'));

    new Hamburger();
  }

  watchForAddingScrollState() {
    document.addEventListener("scroll", () => {
      this.lastKnownScrollY = window.scrollY;
      if (!this.ticking) {
        requestAnimationFrame(this.updateHeader);
        this.ticking = true;
      }
    });
  }

  updateHeader() {
    if (this.lastKnownScrollY > 0) {
      this.header.classList.add("header--scrolled-state");
    } else {
      this.header.classList.remove("header--scrolled-state");
    }
    this.ticking = false;
  }
}
